// frontend/src/components/universal-audit/constants.js

// Storage key used across Universal Audit + Results page
export const STORAGE_KEY = "aifine_public_audit_results";

/**
 * Jurisdiction buttons (UI)
 * IMPORTANT:
 * These keys MUST match the engine + UniversalAuditTool expectations:
 * - UK, EU, US_FED, US_STATE
 */
export const JURIS = [
  { key: "UK", label: "UK", tagId: "uk_gdpr" },
  { key: "EU", label: "EU", tagId: "eu_gdpr" },
  { key: "US_FED", label: "US (FED)", tagId: "us_federal" },
  { key: "US_STATE", label: "US (STATE-BY-STATE)", tagId: "us_states" },
];

// Baseline caps in native currency for that regime (demo baselines)
export const BASE_CAPS = {
  uk_gdpr: 17_500_000, // GBP
  eu_gdpr: 35_000_000, // EUR
  us_federal: 270_000_000, // USD
};

// State list (full)
export const US_STATES = [
  ["AL", "Alabama"],
  ["AK", "Alaska"],
  ["AZ", "Arizona"],
  ["AR", "Arkansas"],
  ["CA", "California"],
  ["CO", "Colorado"],
  ["CT", "Connecticut"],
  ["DE", "Delaware"],
  ["FL", "Florida"],
  ["GA", "Georgia"],
  ["HI", "Hawaii"],
  ["ID", "Idaho"],
  ["IL", "Illinois"],
  ["IN", "Indiana"],
  ["IA", "Iowa"],
  ["KS", "Kansas"],
  ["KY", "Kentucky"],
  ["LA", "Louisiana"],
  ["ME", "Maine"],
  ["MD", "Maryland"],
  ["MA", "Massachusetts"],
  ["MI", "Michigan"],
  ["MN", "Minnesota"],
  ["MS", "Mississippi"],
  ["MO", "Missouri"],
  ["MT", "Montana"],
  ["NE", "Nebraska"],
  ["NV", "Nevada"],
  ["NH", "New Hampshire"],
  ["NJ", "New Jersey"],
  ["NM", "New Mexico"],
  ["NY", "New York"],
  ["NC", "North Carolina"],
  ["ND", "North Dakota"],
  ["OH", "Ohio"],
  ["OK", "Oklahoma"],
  ["OR", "Oregon"],
  ["PA", "Pennsylvania"],
  ["RI", "Rhode Island"],
  ["SC", "South Carolina"],
  ["SD", "South Dakota"],
  ["TN", "Tennessee"],
  ["TX", "Texas"],
  ["UT", "Utah"],
  ["VT", "Vermont"],
  ["VA", "Virginia"],
  ["WA", "Washington"],
  ["WV", "West Virginia"],
  ["WI", "Wisconsin"],
  ["WY", "Wyoming"],
  ["DC", "District of Columbia"],
];

// Default baseline cap (USD) for any selected state not explicitly modeled.
export const DEFAULT_STATE_CAP = 2_000;

// Minimal modeled state caps (USD demo). Others fall back to DEFAULT_STATE_CAP.
export const STATE_CAPS = {
  CA: 3_000,
  NY: 2_500,
  TX: 2_000,
  FL: 2_000,
  IL: 2_000,
  WA: 2_500,
  MA: 2_500,
  CO: 2_000,
};

export function stateIsModeled(code) {
  return Object.prototype.hasOwnProperty.call(STATE_CAPS, code);
}
